import { type FC } from 'react';

import { Picture } from '@/components/ui/Picture/Picture';

import css from './styles.module.scss';

import starsPatternPng from '/img/dice-game/stars-pattern.png';
import starsPatternWebp from '/img/dice-game/stars-pattern.webp';

const ScratchBackground: FC = () => {
  return (
    <div className={css.bg}>
      <div className="relative w-full h-full">
        <div className={css.ellipseTop} />
        <div className={css.ellipseBottom} />
        <Picture
          className="absolute w-full aspect-[444/443] left-1/2 top-0 -translate-x-1/2 mix-blend-screen opacity-80"
          img={starsPatternPng}
          webp={starsPatternWebp}
          alt=""
        />
        <div className={css.radial} />
        <div className={css.shimmer} />
      </div>
    </div>
  );
};

export { ScratchBackground };
